import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const RunningIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="17"
      height="22"
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4896 2.47998C13.4896 3.57998 12.5896 4.47998 11.4896 4.47998C10.3896 4.47998 9.48965 3.57998 9.48965 2.47998C9.48965 1.37998 10.3896 0.47998 11.4896 0.47998C12.5896 0.47998 13.4896 1.37998 13.4896 2.47998ZM8.88965 13.98L7.88965 18.38L0.889648 16.98L1.28965 14.98L6.18965 15.98L7.78965 7.87998L5.98965 8.57998V11.98H3.98965V7.27998L9.18965 5.07998C9.33965 5.07998 9.46465 5.05498 9.58965 5.02998C9.71465 5.00498 9.83965 4.97998 9.98965 4.97998C10.6896 4.97998 11.2896 5.37998 11.6896 5.97998L12.6896 7.57998C13.4896 8.97998 15.0896 9.97998 16.9896 9.97998V11.98C14.7896 11.98 12.7896 10.98 11.4896 9.47998L10.8896 12.48L12.9896 14.48V21.98H10.9896V15.98L8.88965 13.98Z"
        fill="black"
      />
    </SvgIcon>
  )
}
